export var LOCATION_ANALYTIC_EVENT = {
    category: 'location',
    actions: {
        changed: 'location-changed'
    },
    label: {
        location: 'location'
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/common/analytic-events/locationAnalyticEvent.ts
// module id = null
// module chunks = 